import React from 'react';
import { GlobalModals } from 'app/components/MainLayout/components/GlobalModals/GlobalModals';
import { View } from '@upstox/upstox-ui';

export const MainLayout: React.FC = ({ children }) => (
  <View>
    <GlobalModals />
    {children}
  </View>
);
